<script setup lang="ts">
import VersionChecker from "@/components/shared/VersionChecker.vue";
import NavBar from "@/components/shared/navbar/Navbar.vue";
</script>

<template>
  <v-layout style="overflow: clip">
    <nav-bar />
    <v-main>
      <v-container class="tw:!max-w-[1366px] tw:!h-full tw:!pb-16 tw:!px-4 tw:md:!px-6">
        <VersionChecker />
        <router-view />
      </v-container>
    </v-main>
  </v-layout>
</template>

<style scoped></style>
